// @ vendors
const { Promise } = require('es6-promise');
// @ commons
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const {
    MORTGAGE_REQUEST_FETCH_PAYMENT_REQUEST,
    MORTGAGE_REQUEST_FETCH_PAYMENT_SUCCESS,
    MORTGAGE_REQUEST_FETCH_PAYMENT_FAILURE
} = require('constants/actionTypes');

const requestExpensesProvisionInProgress = () => ({
    type: MORTGAGE_REQUEST_FETCH_PAYMENT_REQUEST
});

const requestExpensesProvisionSuccess = (data) => ({
    type: MORTGAGE_REQUEST_FETCH_PAYMENT_SUCCESS,
    data: data
});

const requestExpensesProvisionFailure = (error) => ({
    type: MORTGAGE_REQUEST_FETCH_PAYMENT_FAILURE,
    data: {
        error
    }
});

const requestPayment = () => (dispatch, getState) => {
    const currentState = getState().mortgageRequestPayment;
    const isAlreadyFetching = currentState.get('isFetching');

    if (!isAlreadyFetching) {
        dispatch(requestExpensesProvisionInProgress());

        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestPayment'
        })
            .then(response => {
                return dispatch(requestExpensesProvisionSuccess(response))
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestExpensesProvisionFailure(response.error))
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve()
    }
};

module.exports = {
    requestPayment
};
